module.exports = __webpack_public_path__ + "media/logos/wirwunder_logo-3efc80e2.svg";